import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Card } from '@node-space/ui-components'

export interface RewardsEmbeddedGiveBackProps {
  onDisburse: () => void
  hasBeenDisbursed: boolean
}

export const RewardsEmbeddedGiveBack = ({
  onDisburse,
  hasBeenDisbursed,
}: RewardsEmbeddedGiveBackProps) => {
  const { t } = useTranslation()

  if (hasBeenDisbursed) {
    return null
  }

  return (
    <Box flex className="relative overflow-hidden">
      <Card variant="static" emphasis full>
        <h2 className="text-h2 text-foreground-prominent mb-2">
          {t('rewards.embeddedCustomers.giveBack.title')}
        </h2>
        <Box flex gap={8}>
          <p className="text-body-strong-large text-foreground-subdued flex-1">
            {t('rewards.embeddedCustomers.giveBack.description')}
          </p>
          <Button className="z-10" variant="secondary" onClick={onDisburse}>
            {t('rewards.embeddedCustomers.giveBack.disburse')}
          </Button>
        </Box>
      </Card>

      <Box className="absolute top-[-10px] right-[66px] scale-90">
        <img src={`${process.env.ASSETS_URL}/rewards/curveLine.svg`} alt="Vector" />
      </Box>
    </Box>
  )
}
